import { regionsToRender } from "./changes";
import { regionRenderHash } from "./rendering";
import type { Brick, BrickRegion, MasterImage } from "./types";

// The API issues at most 50 upload keys per request.
const BATCH_SIZE = 20;

export interface RenderedUpload {
  region: string;
  image: string;
  renderHash: string;
}

export interface ApplyDeps<T> {
  render(region: BrickRegion): Promise<Blob>;
  upload(blobs: Blob[]): Promise<string[]>;
  apply(renders: RenderedUpload[]): Promise<T>;
  onProgress?(done: number, total: number): void;
}

export const applyMasterImage = async <T>(
  masterImage: MasterImage,
  bricks: Brick[],
  deps: ApplyDeps<T>
): Promise<T> => {
  if (masterImage.pxPerMm == null) {
    throw new Error("Detect bricks before applying the master image");
  }
  const regions = regionsToRender(masterImage, bricks);
  const renders: RenderedUpload[] = [];
  for (let start = 0; start < regions.length; start += BATCH_SIZE) {
    const batch = regions.slice(start, start + BATCH_SIZE);
    const blobs: Blob[] = [];
    for (const region of batch) blobs.push(await deps.render(region));
    const keys = await deps.upload(blobs);
    batch.forEach((region, i) =>
      renders.push({ region: region.id, image: keys[i], renderHash: regionRenderHash(masterImage, region)! })
    );
    deps.onProgress?.(renders.length, regions.length);
  }
  return deps.apply(renders);
};
